module.exports = __webpack_public_path__ + "img/tab-image-child-presentation.9d81e487.png";